<div class="input-group">
  <div class="input-group-btn">
    <button
      type="button"
      class="btn btn-default dropdown-toggle"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {{ selectedFilterType ? selectedFilterType.displayName : 'Filter' }} <i class="caret"></i>
    </button>
    <ul class="dropdown-menu">
      <li *ngFor="let filterType of filterTypes">
        <a href="javascript:void(0)" (click)="selectFilterType(filterType)">
          {{ filterType.displayName }}
        </a>
      </li>
    </ul>
  </div>
  <input
    #filterElement
    class="form-control"
    type="search"
    name="filter"
    [(ngModel)]="filter"
    (keyup)="filter_keypress($event)"
  />
  <i
    class="input-group-addon fa fa-times"
    [ngClass]="{ hidden: !filter && selectedFilterType === defaultFilterType }"
    (click)="resetClicked()"
  ></i>
  <i class="input-group-addon fa fa-search" (click)="searchClicked()"></i>
</div>
